const getHostParts = () => {
  const hostname = window.location.hostname;
  const parts = hostname.split('.');
  if (parts.length < 2) {
    return { hostname, subdomain: hostname, baseDomain: '' };
  }
  return {
    hostname,
    subdomain: parts[0],
    baseDomain: parts.slice(1).join('.'),
  };
};

const PORTAL_SUBDOMAINS = ['account', 'id', 'ops'];

const getPortalParts = (subdomain) => {
  const portal = PORTAL_SUBDOMAINS.find((name) => subdomain === name || subdomain.endsWith(`-${name}`));
  if (!portal) {
    return { envPrefix: '', portal: 'account' };
  }
  if (subdomain === portal) {
    return { envPrefix: '', portal };
  }
  return {
    envPrefix: subdomain.slice(0, -(portal.length)),
    portal,
  };
};

const buildOrigin = (subdomain, baseDomain) => {
  if (!baseDomain) return window.location.origin;
  return `${window.location.protocol}//${subdomain}.${baseDomain}`;
};

export const getOrigins = () => {
  const { subdomain, baseDomain } = getHostParts();
  const { envPrefix } = getPortalParts(subdomain);
  const accountSub = `${envPrefix}account`;
  const idSub = `${envPrefix}id`;
  const opsSub = `${envPrefix}ops`;
  return {
    accountOrigin: buildOrigin(accountSub, baseDomain),
    idOrigin: buildOrigin(idSub, baseDomain),
    opsOrigin: buildOrigin(opsSub, baseDomain),
  };
};

export const getHostKind = () => {
  const { subdomain } = getHostParts();
  return getPortalParts(subdomain).portal;
};

export const resolveReturnTo = (returnTo) => {
  const target = String(returnTo || '').trim().toLowerCase();
  if (target === 'support') return 'support';
  if (target === 'demo') return 'demo';
  return target === 'ops' ? 'ops' : 'account';
};

export const getReturnToParam = () => {
  const params = new URLSearchParams(window.location.search);
  if (params.get('force_account') === '1') return 'account';
  return resolveReturnTo(params.get('return_to'));
};

export const getPortalLabelFromReturnTo = (returnTo) => {
  const target = resolveReturnTo(returnTo);
  if (target === 'ops') return 'Admin Portal';
  if (target === 'support') return 'Support Portal';
  if (target === 'demo') return 'Demo Portal';
  return 'Account Management';
};

export const getReturnTargetOrigin = (returnTo) => {
  const { accountOrigin, opsOrigin } = getOrigins();
  return resolveReturnTo(returnTo) === 'ops' ? opsOrigin : accountOrigin;
};

export const getReturnTargetPath = (returnTo) => (
  resolveReturnTo(returnTo) === 'ops' ? '/admin' : '/account'
);
